// stores/useAuthClientStore.ts
import { defineStore } from 'pinia'

interface Client {
  _id?: string
  nom: string
  whatsapp: string
  email?: string
  isActive?: boolean
}

interface AuthClientState {
  token: string | null
  client: Client | null
}

export const useAuthClientStore = defineStore('authClient', {
  state: (): AuthClientState => ({
    token: null,
    client: null,
  }),
  getters: {
    isLoggedIn: (state) => !!state.token,
  },
  actions: {
    setAuth(token: string, client: Client) {
      this.token = token
      this.client = client
    },
    setClient(client: Client) {
      this.client = client
    },
    logout() {
      this.token = null
      this.client = null
    },
  },
  persist: true,
})
